module.exports = __webpack_public_path__ + "img/2dd891f.svg";